import { queryPublicPlans } from '@wix/ambassador-pricing-plans-v2-plan/http';
const LIMIT = 100;
export const fetchPricingPlans = async (httpClient, errorHandler, entityIds) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    if (!(entityIds != null && entityIds.length)) {
      return [];
    }
    const pricingPlans = [];
    let hasMore = true;
    let offset = 0;
    do {
      var _data$pagingMetadata;
      const {
        data
      } = await httpClient.request(queryPublicPlans({
        query: {
          filter: entityIds ? {
            id: {
              $in: entityIds
            }
          } : undefined,
          paging: {
            limit: LIMIT,
            offset
          }
        }
      }));
      pricingPlans.push(...(data.plans ?? []));
      offset += LIMIT;
      hasMore = (_data$pagingMetadata = data.pagingMetadata) != null && _data$pagingMetadata.total ? offset < data.pagingMetadata.total : false;
    } while (hasMore);
    return pricingPlans;
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-pricing-plans.js.map